import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import { useIsMobileDevice } from '@swf/poker';

import CreateTournamentBanner from './CreateTournamentBanner/CreateTournamentBanner';
import CreateTournamentContext from './CreateTournamentContext/CreateTournamentContext';
import { TXTCLI_Create_Tournament } from './CreateTournamentFlow.messages.json';
import GameDetails from './GameDetails/GameDetails';
import MainInfo from './MainInfo/MainInfo';
import MoreDetails from './MoreDetails/MoreDetails';
import Recurrence from './Recurrence/Recurrence';
import useCreateClubTournament from './hooks/useCreateClubTournament';
import useGetClubTournamentStructures from './hooks/useGetClubTournamentStructures';

const CreateTournamentFlow: React.FC = () => {
  const { formatMessage } = useIntl();
  const { getClubTournamentStructures } = useGetClubTournamentStructures();
  const { createClubTournament } = useCreateClubTournament();
  const {
    state: { isRecurrenceOpen },
    setState
  } = useContext(CreateTournamentContext);
  const getRecurrence = () => isRecurrenceOpen;
  const isMobileDevice = useIsMobileDevice(true);

  useEffect(() => {
    if (isMobileDevice) {
      setState((prevState) => ({ ...prevState, title: formatMessage(TXTCLI_Create_Tournament) }));
    } else {
      setState((prevState) => ({ ...prevState, title: '' }));
    }
  }, [setState, isMobileDevice, formatMessage]);

  return (
    <StarsWizard.Group
      name="CreateTournamentFlow"
      flow={[
        new Invoke('getClubTournamentStructures', MainInfo),
        new Fork('getRecurrence', [Recurrence], [MainInfo]),
        Recurrence,
        GameDetails,
        MoreDetails,
        new Invoke('createClubTournament', MoreDetails, MoreDetails)
      ]}
      services={{ getClubTournamentStructures, createClubTournament }}
      guards={{ getRecurrence }}
    >
      <MainInfo />
      <CreateTournamentBanner />
      <Recurrence />
      <GameDetails />
      <MoreDetails />
    </StarsWizard.Group>
  );
};

CreateTournamentFlow.displayName = 'CreateTournamentFlow';

export default CreateTournamentFlow;
